<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-wyslane' aria-label='Wnioski wysłane'>
        Wnioski wysłane
      </a>
    </li>
    <li>
      {{ serviceType()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert-container [dismissible]='false'></app-alert-container>
    @if (!loading()) {
      <div class='download-actions' *ngIf='application()'>
        <a href='#' title='Pobierz wniosek PDF' class='btn btn-secondary' (click)='onDownloadApplicationPdf($event)'>
          <i aria-hidden='true' class='fa fa-file-download'></i>
          Pobierz wniosek PDF
        </a>
        <a href='#' title='Pobierz UPD' class='btn btn-secondary' (click)='onDownloadUPP($event)'>
          <i aria-hidden='true' class='fa fa-download'></i>
          Pobierz UPP
        </a>
      </div>
      <h2>
        {{ serviceType()?.name }}
      </h2>
      <app-carrying-out-works-preview
        *ngIf="contentUrl === 'zajecie-pasa-prowadzenie-robot'"
        [application]='application()'>
      </app-carrying-out-works-preview>
      <app-location-reconstruction-of-exit-preview
        *ngIf="contentUrl === 'lokalizacja-przebudowa-zjazdu'"
        [application]='application()'>
      </app-location-reconstruction-of-exit-preview>
      <app-notification-of-emergency-preview
        *ngIf="contentUrl === 'awaryjne-zajecie-pasa-drogowego'"
        [application]='application()'>
      </app-notification-of-emergency-preview>
      <app-location-of-devices-unrelated-to-road-preview
        *ngIf="contentUrl === 'umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'"
        [application]='application()'>
      </app-location-of-devices-unrelated-to-road-preview>
      <app-localisation-devices-unrelated-to-road-preview
        *ngIf="contentUrl === 'lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'"
        [application]='application()'>
      </app-localisation-devices-unrelated-to-road-preview>
      <app-approval-of-traffic-organization-projects-preview
        *ngIf="contentUrl === 'zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych'"
        [application]='application()'>
      </app-approval-of-traffic-organization-projects-preview>
      <app-opinion-on-the-project-of-traffic-org-preview
        *ngIf="contentUrl === 'opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych'"
        [application]='application()'>
      </app-opinion-on-the-project-of-traffic-org-preview>
      <app-placement-advertising-preview
        *ngIf="contentUrl === 'umieszczenie-reklamy'"
        [application]='application()'>
      </app-placement-advertising-preview>
      <app-compensation-for-losses-preview
        *ngIf="contentUrl === 'odszkodowanie-za-straty'"
        [application]='application()'>
      </app-compensation-for-losses-preview>
      <app-opinion-on-issuing-a-decision-preview
        *ngIf="contentUrl === 'opinia-w-sprawie-wydania-decyzji'"
        [application]='application()'>
      </app-opinion-on-issuing-a-decision-preview>
      <app-public-information-disclosure-preview
        *ngIf="contentUrl === 'udostepnienie-informacji-publicznej'"
        [application]='application()'>
      </app-public-information-disclosure-preview>
      <app-notification-general-remarks-road-marking-preview
        *ngIf="contentUrl === 'zgloszenie-uwagi-ogolne-oznakowanie-drog'"
        [application]='application()'>
      </app-notification-general-remarks-road-marking-preview>
      <app-consent-reconstruction-renovation-of-buildings-preview
        *ngIf="contentUrl === 'zgoda-przebudowa-remont-obiektow-budowlanych'"
        [application]='application()'>
      </app-consent-reconstruction-renovation-of-buildings-preview>
      <app-documents-information-preview
        *ngIf="contentUrl === 'uzupelnienie-dokumentow'"
        [application]='application()'>
      </app-documents-information-preview>
      <app-general-letter-preview
        *ngIf="contentUrl === 'pismo-ogolne'"
        [application]='application()'>
      </app-general-letter-preview>
      <app-response-to-call-preview
        *ngIf="contentUrl === 'odpowiedz-na-wezwanie'"
        [application]='application()'>
      </app-response-to-call-preview>
      <app-occupation-of-lane-placement-construction-objects-preview
        *ngIf="contentUrl === 'zajecie-pasa-umieszczenie-obiektow-budowlanych'"
        [application]='application()'>
      </app-occupation-of-lane-placement-construction-objects-preview>
      <app-take-over-lane-reconstruction-of-exit-preview
        *ngIf="contentUrl === 'zajecie-pasa-budowa-przebudowa-zjazdu'"
        [application]='application()'>
      </app-take-over-lane-reconstruction-of-exit-preview>
      <app-permit-for-oversize-vehicles-preview
        *ngIf="contentUrl === 'zezwolenie-przejazdy-pojazdow-nienormatywnych'"
        [application]='application()'>
      </app-permit-for-oversize-vehicles-preview>
    }
    <ng-container *ngIf='!loading()'>
      <br>
      <div class='application-actions'>
        <button
          type='button'
          class='btn btn-secondary' routerLink='../../'>
        <span>
          Wstecz
        </span>
        </button>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
